// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"maintenance_wrapper__2LuqB","maintenance":"maintenance_maintenance__14rAo","logo":"maintenance_logo__1aA6u","message":"maintenance_message__1d2Z0"};